import api from "@utils/api";

export const getEmployees = (id, page, rowsPerPage) => api.get(`/employee/organizacion/${id}?page=${page}&per_page=${rowsPerPage}`);
export const getEmployeesSP = (id) => api.get(`/employee/organizacionSP/${id}`);
export const getEmployeeById = (id) => api.get(`/employee/${id}`);
export const getEmployeeByPlaceId = (id, page, rowsPerPage) => api.get(`/employee/place/${id}?page=${page}&per_page=${rowsPerPage}`);
export const getEmployeeByPlaceIdSP = (id) => api.get(`/employee/placeSP/${id}`);
export const createEmployee = (employee) => api.post("/employee", employee);
export const updateEmployee = (id, employee) =>
  api.put(`/employee/${id}`, employee);
export const deleteEmployee = (id) => api.delete(`/employee/${id}`);

// Multi-sede: sedes del empleado + asignar/quitar una sede.
// Asignar registra a la persona en las cámaras de esa sede; quitar la des-enrola
// de las cámaras de esa sede (conservando su log). Quitar la única sede -> 409.
export const getEmployeePlaces = (id) => api.get(`/employee/${id}/places`);
export const addEmployeePlace = (id, placeId) => api.post(`/employee/${id}/place/${placeId}`);
export const removeEmployeePlace = (id, placeId) => api.delete(`/employee/${id}/place/${placeId}`);

export const getEmployeeByDocument = (document) => api.get(`/employee/cedula/${document}`);

// Coordinadores de área ya usados (para el autocomplete del alta/edición de empleado).
export const getCoordinadores = (idOrganizacion) =>
  api.get("/employee/coordinadores", {
    params: idOrganizacion ? { id_organizacion: idOrganizacion } : {},
  });

export const getExcelAllEmployees = async (idOrganizacion) => {
  try {
    const response = await api.get(`/employee/export/excel?id_organizacion=${idOrganizacion}`);
    return response.data;
  } catch (error) {
    throw new Error(`Error al obtener el archivo Excel: ${error.message}`);
  }
};

export const getExcelAllEmployeesS3 = async (idOrganizacion) => {
  try {
    const response = await api.get(
      `/employee/export/excel_s3?id_organizacion=${idOrganizacion}`
    );
    return response.data;
  } catch (error) {
    throw new Error(`Error al obtener el archivo Excel desde S3: ${error.message}`);
  }
};
